module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("hQDxa"))).then(() => parcelRequire('7FBZw'));